/**
 * @module builder
 */

import type { OptionsDocument, QuoteDocument } from 'paintscout'

import { calculate } from '../../../../calculator/calculate'
import { buildSubstrates } from '../../../../calculator/substrates/build-substrates'
import { sanitizeSubstrates } from '../../../../calculator/substrates/sanitize-substrates'
import { generateProductDescription } from '../generate-product-description/generate-product-description'

export function calculateQuote(args?: { quote: QuoteDocument; options: OptionsDocument }): QuoteDocument {
  const { quote, options } = args ?? {}

  const builtSubstrates = buildSubstrates(quote, options)

  const calculatedQuote = calculate(builtSubstrates, options)

  const sanitizedQuote = sanitizeSubstrates(calculatedQuote)

  sanitizedQuote.productString = {
    ...sanitizedQuote.productString,
    default: generateProductDescription({ quote, options })
  }

  // Same deal for the work order's Additional Work description: keep `default` in step with the
  // additional-work items so an estimator's `custom` override is the only thing that ever pins it.
  sanitizedQuote.additionalProductString = {
    ...sanitizedQuote.additionalProductString,
    default: generateProductDescription({ quote, options, section: 'additional' })
  }

  return sanitizedQuote
}
